import {useCallback} from "react";
import {useCartContext} from "@/components/Providers/CartProvider.tsx";

type ScriptResult = {
    message: string;
    errorCode: number;
    data: unknown;
};

const useFMCartPerson = () => {
    const {cart} = useCartContext();

    return useCallback(async (): Promise<string | undefined> => {
        if (!(window.FileMaker && cart?.id)) {
            console.error("invalid context", !(window.FileMaker && cart?.id));
            return "An error occurred (-1)";
        }

        try {
            const fmCallBack = new Promise<string>(resolve => {
                let resolved = false;
                window.FileMakerCallback = (response: string) => {
                    resolved = true;
                    resolve(`${response}`);
                };
                setTimeout(() => {
                    if (!resolved) {
                        resolve(
                            JSON.stringify({
                                message: "FileMaker Call timed out",
                                errorCode: 100,
                                data: null,
                            } satisfies ScriptResult),
                        );
                    }
                }, 10_000); //wait 10 seconds
            });
            window.FileMaker.PerformScript(
                "patchCartInPersonTerminal",
                JSON.stringify({
                    cartId: cart?.id,
                }),
            );

            const fmResponse = JSON.parse(await fmCallBack) as ScriptResult;
            if (fmResponse.errorCode !== 0) {
                console.error("fmResponse", fmResponse);
                return fmResponse.message
                    ? `${fmResponse.message}`
                    : "There was an error setting the terminal user";
            }
            return;
        } catch (e) {
            console.error("error in useCashPayment", e);
        }
        return "There was an error setting the terminal user.";
    }, [cart?.id]);
};

export default useFMCartPerson;
